export default __webpack_public_path__ + "static/media/myalgo.439c14ae.svg";